<template>
    <div class="phone-panel">
        <div class="phone-panel__header">
            <div>
                <span class="phone-panel__eyebrow">Contatos</span>
                <h6 :class="required ? 'required': ''">
                    <i class="icon-phone"/> {{ t('GENERAL.PHONE') }}s
                </h6>
                <small>Cadastre um ou mais telefones para contato.</small>
            </div>
            <span class="phone-panel__counter">
                {{ phones.length }} {{ phones.length === 1 ? 'telefone' : 'telefones' }}
            </span>
        </div>

        <div class="phone-panel__draft">
            <div class="phone-panel__draft-title">
                <span>Novo telefone</span>
                <small>Preencha os dados antes de adicionar a lista.</small>
            </div>
            <div class="row gutters">
                <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                    <div data-cy="user_index_add_type_phone" class="form-group">
                        <label :class="verifyRequired">{{ t('GENERAL.PHONE_TYPE') }}: </label>
                        <Select2 data-cy="phone_type"
                                 :settings="{width: '100%', placeholder: t('GENERAL.MSG.SELECT_ONE', {article: 'um', name: t('GENERAL.TYPE')})}"
                                 :options="types"
                                 v-model="type"
                                 @select="alterType"
                                 id="type"
                                 name="type"/>
                        <div class="validation" id="invalidType" style="display: none">
                            {{ t('GENERAL.MSG.REQUIRED_FIELD') }}
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                    <div class="form-group">
                        <label for="phone" :class="verifyRequired">{{ t('COMPANIES.NUMBER') }}: </label>
                        <vue-tel-input
                                mode="national"
                                @input="alterNumber"
                                v-model="number"
                                :autoFormat="true"
                                :preferredCountries="['US', 'DE', 'FR', 'CN']"
                                :defaultCountry="codeNumber"
                                @country-changed="changeCountry"
                                :dropdownOptions="dropdownOptions"
                                :inputOptions="inputOptions"
                        ></vue-tel-input>
                        <div class="validation" id="invalidphone" style="display: none">
                            {{ t(msgPhone) }}
                        </div>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-4 col-md-12 col-sm-12 col-12">
                    <div class="form-group">
                        <label>{{ t("GENERAL.COMMENT") }}:</label>
                        <input class="form-control"
                               v-model="description"
                               type="text"
                               @change.stop.prevent="alterDescription"
                               maxlength="60">
                    </div>
                </div>
                <div class="col-xl-2 col-lg-12 col-md-12 col-sm-12 col-12 d-flex align-items-center">
                    <button class="btn btn-primary phone-panel__add" @click.prevent.stop="createPhone">
                        <i class="icon-plus"></i> Novo telefone
                    </button>
                </div>
            </div>
        </div>

        <div v-if="phones.length" class="phone-panel__list">
            <div class="phone-panel__item" v-for="(phone, key) in phones" :key="phone.id || key">
                <div class="phone-panel__avatar">
                    <i class="icon-phone"></i>
                </div>
                <div class="phone-panel__fields">
                    <div class="row gutters">
                        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div data-cy="user_index_add_type_phone" class="form-group">
                                <label>{{ t('GENERAL.PHONE_TYPE') }}</label>
                                <Select2
                                        data-cy="phone_type"
                                        :settings="{width: '100%', placeholder: t('GENERAL.MSG.SELECT_ONE', {article: 'um', name: t('GENERAL.TYPE')})}"
                                        :options="types"
                                        v-model="phone.type"
                                        @select="updatePhone"/>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div class="form-group">
                                <label>{{ t('COMPANIES.NUMBER') }}</label>
                                <vue-tel-input
                                        mode="national"
                                        @country-changed="changeCountry($event,key)"
                                        @input="updatePhone"
                                        :autoFormat="true"
                                        :preferredCountries="['US', 'DE', 'FR', 'CN']"
                                        v-model="phone.number"
                                        :defaultCountry="parseInt(phone.code_country)"
                                        :dropdownOptions="dropdownOptions"
                                        :inputOptions="inputOptions"
                                ></vue-tel-input>
                            </div>
                        </div>
                        <div class="col-xl-5 col-lg-4 col-md-12 col-sm-12 col-12">
                            <div class="form-group">
                                <label>{{ t("GENERAL.COMMENT") }}</label>
                                <input
                                        class="form-control"
                                        v-model="phone.description"
                                        type="text"
                                        @change="updatePhone"
                                        maxlength="60">
                            </div>
                        </div>
                    </div>
                </div>
                <button type="button"
                        class="btn btn-outline-danger btn-sm phone-panel__remove"
                        v-if="!isView"
                        @click="deletePhone(key)">
                    Remover
                </button>
            </div>
        </div>
        <div v-else class="phone-panel__empty">
            Nenhum telefone adicionado. Informe os dados acima e clique em novo telefone.
        </div>
    </div>
</template>

<script>

import {useI18n} from "vue-i18n";
import {useToast} from "vue-toastification";
import Select2 from 'vue3-select2-component';
import Validate from '@/components/validate.vue';
import {VueTelInput} from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

export default {
    name: 'phone',
    mixins: [Validate],
    emits: ['cleaned', 'alterDescription', 'alterType', 'alterNumber', 'create', 'update'],
    props: {
        phonesIndex: {
            type: Array,
            defaut: [],
        },
        isView: {
            type: Boolean,
            defaut: false,
        },
        required: {
            type: Boolean,
            defaut: false,
        },
        isInvalid: {
            defaut: false,
        },
        clearDataPhone: {
            defaut: false,
        }
    },
    components: {
        Select2,
        VueTelInput
    },
    computed: {
        verifyRequired() {
            if (this.required && !this.phones?.length) {
                return 'required';
            }
            if (this.required && this.phones?.length) {
                return '';
            }
            if (!this.required) {
                return '';
            }
            return 'required';
        },
    },
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },

    data() {
        return {
            dropdownOptions: {
                showDialCodeInList: true,
                showDialCodeInSelection: true,
                showFlags: true,
                showSearchBox: true,
                tabindex: 3,
            },
            inputOptions: {
                autocomplete: 'on',
                autofocus: true,
                'aria-describedby': 'des',
                showDialCode: false,
                placeholder: 'Numero Telefone',
                tabindex: 3,
                maxlength: 19,
            },
            codeNumber: 55,
            country_acronym: 'BR',
            add: false,
            type: 2,
            phones: [],
            types: [
                {id: 0, text: 'Whatsapp'},
                {id: 1, text: 'Ligação'},
                {id: 2, text: 'Ligação e Whatsapp'}
            ],
            number: '',
            description: null,
        }
    },
    watch: {
        isInvalid: function (val) {
            if (val) {
                document.getElementById('phone')?.classList?.add("is-invalid");
            } else {
                document.getElementById('phone')?.classList?.remove('is-invalid');
            }
        },
        phonesIndex: function () {
            this.add = false;
            this.phones = this.phonesIndex ? this.phonesIndex : [];
        },
        clearDataPhone(val) {
            if (val) {
                this.type = 2;
                this.description = null;
                this.number = '';
                this.$emit('cleaned', true);
            }
        }
    },
    created() {
        this.phones = this.phonesIndex ? this.phonesIndex : [];
    },
    methods: {
        changeCountry(val, key = null) {
            if (key){
               this.phones.forEach((i,k) => {
                   if (k === key){
                       i.code_country = val.dialCode;
                       i.country_acronym = val.iso2;
                   }
               });
               this.updatePhone();
               return;
            }
            this.codeNumber = val.dialCode;
            this.country_acronym = val.iso2;
            this.alterNumber();
        },
        alterDescription() {
            this.$emit('alterDescription', this.description)
        },
        alterType() {
            this.$emit('alterType', this.type)
        },
        alterNumber() {
            this.$emit('alterNumber', {number: this.number, code_country: this.codeNumber, country_acronym: this.country_acronym})
        },
        createPhone() {
            this.invalid = [];
            if (this.type == null) {
                this.invalid.push(true);
                document.getElementById("invalidType").style.display = "block";
            } else {
                document.getElementById("invalidType").style.display = "none";
            }
            if (this.invalid.length == 0) {
                this.phones.push({
                    code_country: this.codeNumber,
                    country_acronym: this.country_acronym,
                    type: this.type >= 0 ? this.type : 2,
                    number: this.number,
                    description: this.description
                });
                this.type = 2;
                this.number = '';
                this.description = null;
                this.$emit('create', this.phones);
            }
        },
        updatePhone() {
            this.$emit('update', this.phones);
        },
        deletePhone(key) {
            this.phones.splice(key, 1);
            this.$emit('update', this.phones);
        },
        validate(input, id) {
            if (input && (input.length == 14 || input.length == 15)) {
                document.getElementById(id).classList.add("is-valid");
                return true;
            } else {
                document.getElementById(id).classList.add("is-invalid");
                return false;
            }
        },
    }
}
</script>

<style scoped>
.phone-panel {
    background:
        radial-gradient(ellipse at 0% 0%, rgba(14, 94, 78, 0.08), rgba(14, 94, 78, 0.035) 24%, transparent 58%),
        linear-gradient(135deg, #ffffff 0%, #fbfcfd 58%, #f7f9fb 100%);
    border: 1px solid #dce3ea;
    border-radius: 14px;
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.88),
        0 12px 28px rgba(15, 23, 42, 0.06);
    margin: 7px 0 7px;
    padding: 18px;
}

.phone-panel__header,
.phone-panel__item {
    align-items: center;
    display: flex;
    gap: 14px;
    justify-content: space-between;
}

.phone-panel__eyebrow {
    color: #0e5e4e;
    display: block;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: .08em;
    text-transform: uppercase;
}

.phone-panel h6 {
    color: #173b34;
    font-weight: 700;
    margin: 2px 0;
}

.phone-panel small {
    color: #6b7c78;
}

.phone-panel__counter {
    background: #e7f4f0;
    border-radius: 999px;
    color: #0e5e4e;
    font-size: 12px;
    font-weight: 700;
    padding: 8px 12px;
    white-space: nowrap;
}

.phone-panel__list {
    display: grid;
    gap: 10px;
    margin-top: 16px;
}

.phone-panel__item {
    background: #ffffff;
    border: 1px solid #e3eeeb;
    border-radius: 12px;
    padding: 12px;
}

.phone-panel__avatar {
    align-items: center;
    background: #0e5e4e;
    border-radius: 12px;
    color: #ffffff;
    display: flex;
    flex: 0 0 42px;
    height: 42px;
    justify-content: center;
}

.phone-panel__fields {
    flex: 1;
    min-width: 0;
}

.phone-panel__remove {
    white-space: nowrap;
}

.phone-panel__empty {
    background: rgba(14, 94, 78, 0.06);
    border: 1px dashed #b9d8d0;
    border-radius: 12px;
    color: #52716a;
    font-size: 13px;
    margin-top: 16px;
    padding: 12px;
}

.phone-panel__draft {
    background: rgba(255, 255, 255, 0.78);
    border: 1px solid #e3eeeb;
    border-radius: 12px;
    margin-top: 14px;
    padding: 14px;
}

.phone-panel__draft-title {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
}

.phone-panel__draft-title span {
    color: #173b34;
    font-weight: 700;
}

.phone-panel label {
    color: #617470;
    font-size: 12px;
    font-weight: 700;
}

.phone-panel .form-control,
.phone-panel ::v-deep .vue-tel-input {
    border-radius: 10px;
    min-height: 38px;
}

.phone-panel__add {
    border-radius: 10px;
    min-height: 38px;
    width: 100%;
}

:global(html.dark-theme .phone-panel ){
    background:
        radial-gradient(ellipse at 0% 0%, rgba(20, 184, 166, 0.20), rgba(20, 184, 166, 0.10) 24%, transparent 58%),
        linear-gradient(135deg, rgba(17, 24, 39, 0.98) 0%, rgba(23, 32, 51, 0.96) 100%) !important;
    border-color: rgba(94, 234, 212, 0.18) !important;
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.04),
        inset 0 0 0 1px rgba(148, 163, 184, 0.08),
        -14px -12px 38px rgba(20, 184, 166, 0.11),
        0 18px 42px rgba(2, 6, 23, 0.36) !important;
    color: var(--dark-text-soft) !important;
}

:global(html.dark-theme .phone-panel h6),
:global(html.dark-theme .phone-panel__draft-title span ){
    color: var(--dark-text) !important;
}

:global(html.dark-theme .phone-panel__eyebrow),
:global(html.dark-theme .phone-panel__avatar ){
    color: var(--dark-primary) !important;
}

:global(html.dark-theme .phone-panel small),
:global(html.dark-theme .phone-panel label ){
    color: var(--dark-text-muted) !important;
}

:global(html.dark-theme .phone-panel__counter ){
    background: var(--dark-primary-soft) !important;
    color: var(--dark-text) !important;
}

:global(html.dark-theme .phone-panel__item),
:global(html.dark-theme .phone-panel__draft ){
    background: var(--dark-surface-2) !important;
    border-color: var(--dark-border) !important;
}

:global(html.dark-theme .phone-panel__empty ){
    background: var(--dark-primary-soft) !important;
    border-color: var(--dark-border-strong) !important;
    color: var(--dark-text-soft) !important;
}

:global(html.dark-theme .phone-panel__avatar ){
    background: var(--dark-surface-3) !important;
}

::v-deep .vti__dropdown-list  {
    z-index: 4 !important;
}
::v-deep .vti__dropdown-list{
    width: 25vw;
    max-width: 340px;
    max-height: 35vh;
}
@media (max-width: 1199px) {
    ::v-deep .vti__dropdown-list{
        width: 22vw;
        max-width: 230px;
    }
}
@media (max-width: 990px) {
    ::v-deep .vti__dropdown-list{
        width: 24vw;
        max-width: 130px;
    }
}
@media (max-width: 575px) {
    .phone-panel {
        padding: 16px;
    }

    .phone-panel__header,
    .phone-panel__item {
        align-items: flex-start;
        flex-direction: column;
    }

    .phone-panel__counter {
        align-self: flex-start;
    }

    .phone-panel__avatar {
        display: none;
    }

    .phone-panel__fields,
    .phone-panel__remove {
        width: 100%;
    }

    ::v-deep .vti__dropdown-list{
        width: 45vw;
        max-width: 260px;
    }
}
</style>
